<template>
  <div class="distributor-address-list">
    <gobuy-head :title="$t('Country/Region')" />
    <div class="main-content country-select-page">
      <!-- 搜索框 -->
      <input
        type="text"
        v-model="searchQuery"
        :placeholder="$t('Search')"
        class="search-input"
      />
      <!-- 国家列表 -->
      <ul class="country-list">
        <li
          v-for="(country, index) in filteredCountries"
          :key="country.name + index"
          @click="selectCountry(country)"
        >
          <div>
            <span :class="['country-flag', country.flag_code]"></span>
            {{ country.name }}
          </div>
          <span class="code">{{ country.code }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import '../../../assets/style/country.scss';
import { getArea } from '../../../api/area';

export default {
  data() {
    return {
      countries: [],
      searchQuery: ''
    };
  },
  created() {
    this.loadCountries();
  },
  computed: {
    filteredCountries() {
      const query = this.searchQuery.toLowerCase().trim();
      return this.countries.filter(country =>
        country.name.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    loadCountries() {
      getArea().then(res => {
        this.countries = res.result.area_list.map(country => ({
          ...country,
          flag_code: country.flag_code
        }));
      }).catch(error => {
        this.$toast(error.message);
      });
    },
    selectCountry(country) {
      console.log(this.$route.query.address_id)
      this.$router.push({ name: 'MemberAddressForm', query: {
        area_id: country.area_id,
        name: country.name,
        code: country.code,
        flag: country.flag_code,
        address_id: this.$route.query.address_id || '',
        action: this.$route.query.action,
        selected: 1
      } });
    }
  }
};
</script>
<style>
#app{background-color: #ffffff;}
</style>
<style scoped>
.country-select-page {
  font-size: 0.7rem;
  padding: 20px;
}

.search-input {
  width: 92%;
  top: 4.3rem;
  padding: 13px 15px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: fixed;
  z-index: 99;
  background-color: #ffffff;
}

.country-list {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 120px;
}

.country-list li {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.country-list li:hover {
  background-color: #f0f0f0;
}

</style>